import { render, staticRenderFns } from "./SectionPageHero.vue?vue&type=template&id=1b83f1ed&scoped=true"
import script from "./SectionPageHero.vue?vue&type=script&lang=js"
export * from "./SectionPageHero.vue?vue&type=script&lang=js"
import style0 from "./SectionPageHero.vue?vue&type=style&index=0&id=1b83f1ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83f1ed",
  null
  
)

export default component.exports